var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRankings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86198 0.611515V6.10034H2.31309V1.21267L1.08464 1.57859L0.940887 1.10812L2.39151 0.60498H2.86198V0.611515Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.219 6.17909H7.58641C7.58641 4.62392 8.84753 3.36279 10.4027 3.36279C11.9579 3.36279 13.219 4.62392 13.219 6.17909Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6377 1.85999C11.6377 2.53956 11.0823 3.36288 10.4027 3.36288C10.2198 3.36288 10.0433 3.30407 9.8865 3.19952C9.74928 3.11458 9.63166 3.00349 9.53365 2.87281H9.52712C9.29841 2.57876 9.16119 2.19977 9.16119 1.85999C9.16119 1.5202 9.29188 1.21962 9.52058 0.984388C9.74928 0.749152 10.0695 0.625 10.3962 0.625C11.0757 0.625 11.6312 1.18042 11.6312 1.85999H11.6377Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.617 2.09473H27.3788",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6169 4.70898H27.3787",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.411575 14.7976L2.38494 12.8046C2.84888 12.3407 3.2344 11.8637 3.2344 11.354C3.2344 10.6091 2.69205 10.2431 2.1301 10.2431C1.59429 10.2431 1.16302 10.4784 0.901649 11.0207L0.437713 10.7463C0.790566 10.0471 1.43093 9.71387 2.1301 9.71387C2.94689 9.71387 3.78329 10.2889 3.78329 11.3605C3.78329 12.0597 3.31935 12.6478 2.76393 13.2032L1.19569 14.7649H3.9009V15.3007H0.411575V14.8041V14.7976Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.062 15.327H7.42938C7.42938 13.7719 8.69051 12.5107 10.2457 12.5107C11.8008 12.5107 13.062 13.7719 13.062 15.327Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4807 11.0079C11.4807 11.6875 10.9253 12.5108 10.2457 12.5108C10.0627 12.5108 9.8863 12.452 9.72948 12.3475C9.59226 12.2625 9.47464 12.1514 9.37662 12.0208H9.37009C9.14139 11.7267 9.00417 11.3477 9.00417 11.0079C9.00417 10.6682 9.13485 10.3676 9.36355 10.1323C9.59225 9.8971 9.91244 9.77295 10.2392 9.77295C10.9187 9.77295 11.4741 10.3284 11.4741 11.0079H11.4807Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6169 11.2432H27.3787",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6169 13.8564H27.3787",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91403 22.8938C3.91403 23.985 3.03843 24.5796 2.07135 24.5796C1.2807 24.5796 0.57499 24.2137 0.307083 23.4884L0.764486 23.2205C0.947447 23.7759 1.44406 24.0438 2.07135 24.0438C2.78359 24.0438 3.36515 23.6518 3.36515 22.8938C3.36515 22.1358 2.78359 21.7437 2.07135 21.7437H2.06482H1.91453L1.67929 21.3844L3.04496 19.5221H0.470441V19.0059H3.68533V19.5221L2.4046 21.2863C3.22793 21.3974 3.91403 21.9398 3.91403 22.9003V22.8938Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.062 24.4423H7.42944C7.42944 22.8871 8.69057 21.626 10.2457 21.626C11.8009 21.626 13.062 22.8871 13.062 24.4423Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4807 20.1295C11.4807 20.8091 10.9253 21.6324 10.2458 21.6324C10.0628 21.6324 9.88638 21.5736 9.72955 21.4691C9.59233 21.3841 9.47471 21.273 9.3767 21.1423H9.37016C9.14146 20.8483 9.00424 20.4693 9.00424 20.1295C9.00424 19.7897 9.13493 19.4892 9.36363 19.2539C9.59233 19.0187 9.91251 18.8945 10.2392 18.8945C10.9188 18.8945 11.4742 19.4499 11.4742 20.1295H11.4807Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.617 20.3584H27.3788",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6171 22.9727H27.3789",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRankings);
export default __webpack_public_path__ + "static/media/newRankings.ca820a5b6e2e8607600c7152bdce2577.svg";
export { ForwardRef as ReactComponent };